import { IError } from '@checkout/errors';
import { IRegisterRequestPayload } from '@checkout/payloadTypes';
import { IRegisterFieldsData } from '@checkout/state';
import * as cx from 'classnames';
import { Form, Formik, FormikActions } from 'formik';
import * as React from 'react';
import { Fragment } from 'react';
import { FormikErrorFocus } from '..';
import { Button, MembershipHeader, MessageBox } from '../../presentational';
import { registerRequest } from './../../../reducers/checkout';
import * as Styles from './RegisterFormWizard.scss';

interface IOwnProps {
  isFolded: boolean;
  isCustomerClubFieldsVisible: boolean;
  errors?: IError;
  initialValues: IRegisterFieldsData;
  onSubmit: typeof registerRequest;
}

interface IOwnState {
  step: number;
  values: IRegisterFieldsData;
}

type Props = IOwnProps;

interface IStep {
  children: React.ReactElement<any>;
  isLast?: boolean;
  validate?: (values: IRegisterFieldsData) => Promise<{}>;
}

class RegisterFormWizard extends React.Component<Props, IOwnState> {
  static Step = ({ children }: IStep) => children;

  state: IOwnState = {
    step: 0,
    values: this.props.initialValues
  };

  componentDidUpdate() {
    if (this.props.isFolded && this.state.step > 0) {
      this.setState({ step: 0 });
    }
  }

  handleNextStep = (values: IRegisterFieldsData) => {
    if (this.props.children) {
      this.setState({
        step: Math.min(this.state.step + 1, React.Children.count(this.props.children) - 1),
        values,
      });
    }
  }

  handlePrevStep = () => {
    this.setState({ step: Math.max(this.state.step - 1, 0) });
  }

  validate = (values: IRegisterFieldsData) => {
    const activeStep = React.Children.toArray(this.props.children)[this.state.step] as React.ReactElement<any>;

    return activeStep.props.validate ? activeStep.props.validate(values) : {};
  }

  onSubmit = (values: IRegisterFieldsData, actions: FormikActions<IRegisterFieldsData>) => {
    const { passwordConfirm: _, identityNumber: __, physicalStore, address2: ___, ...restValues } = values.register;
    const { children, isCustomerClubFieldsVisible } = this.props;
    const { step } = this.state;
    const activeStep = React.Children.toArray(children)[step] as React.ReactElement<any>;
    const isLastPage = activeStep.props.isLast;
    // const isLastPage = step === React.Children.count(React.Children.toArray(children).filter(child => child)) - 1;

    const registerPayload: IRegisterRequestPayload = {
      ...restValues,
      customerClubFields: isCustomerClubFieldsVisible ? {
        socialnr: values.register.identityNumber,
        primaryStore: values.register.physicalStore && values.register.physicalStore.store,
      } : undefined,
    };

    if (isLastPage) {
      this.props.onSubmit(registerPayload);
    } else {
      this.handleNextStep(values);
      actions.setTouched({});
      actions.setSubmitting(false);
    }
  }

  render() {
    const { isFolded, errors, children } = this.props;
    const { step, values } = this.state;
    const activeStep = React.Children.toArray(children)[step] as React.ReactElement<any>;
    // const isLastStep = step === React.Children.count(React.Children.toArray(children).filter(child => child)) - 1;
    const isLastStep = activeStep.props.isLast;

    const buttonsClassNames = cx({
      [Styles.buttons]: step > 0,
    });

    return (
      <div className={Styles.form}>
        <MembershipHeader title="Sign up" subTitle="It takes less than one minute" />
        {!isFolded && (
          <Fragment>
            {errors && errors.uiType === 'inline' && <MessageBox spacingBottom={true} type="error" message={errors.messages[0]} />}
            <Formik<IRegisterFieldsData, {}>
              initialValues={{ ...values }}
              validate={this.validate}
              enableReinitialize={false}
              onSubmit={this.onSubmit}
              render={formik => {

                const activeStepWithChildrenProps = React.cloneElement(activeStep.props.children, { formikContext: formik });

                return (
                  <Form className={Styles.form}>

                    {activeStepWithChildrenProps} {/* Children */}

                    <div className={buttonsClassNames}>
                      {step > 0 && (
                        <Button type="button" variant="clear" onClick={this.handlePrevStep} align="center" size="medium" width="long" label="Back" />
                      )}
                      {!isLastStep && (
                        <Button type="submit" variant="primary" align="center" size="medium" width="long" label="Continue" />
                      )}
                      {isLastStep && (
                        <Button
                          type="submit"
                          variant="primary"
                          align="center"
                          size="medium"
                          width={step === 0 ? 'long' : undefined}
                          label="Create an account"
                        />
                      )}
                    </div>

                    <FormikErrorFocus formikContext={formik} />
                  </Form>
                );
              }}
            />
          </Fragment>
        )}
      </div>
    );
  }
}

export default RegisterFormWizard;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/container/RegisterFormWizard/RegisterFormWizard.tsx